import {
  checkoutAddressSubscriptionActivateApi,
  checkoutPaymentSubscriptionActivateApi
} from 'api/subscriptionActivate';
import { formatErrorMessage } from 'libs/notice';
import {
  signinWebAuth,
  signupWebAuth,
  socialAuthorizationWebAuth,
  resetPasswordWebAuth
} from 'api/webAuth';
import { updateAdditionalInfoApi } from 'api/account';
import { fetchPlanCurrencyApi } from 'api/musePlans';
import { processAuthInfoForAdditionalInfo, authCallback } from 'libs/auth';
// ------------------------------------
// Constants
// ------------------------------------
export const CHECKOUT_SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_START = 'CHECKOUT_SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_START';
export const CHECKOUT_SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_END = 'CHECKOUT_SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_END';
export const SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_ERROR = 'SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_ERROR';
export const CHECKOUT_SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_START = 'CHECKOUT_SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_START';
export const CHECKOUT_SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_END = 'CHECKOUT_SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_END';
export const SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_ERROR = 'SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_ERROR';
export const CHECKOUT_SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_START = 'CHECKOUT_SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_START';
export const CHECKOUT_SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_END = 'CHECKOUT_SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_END';
export const SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_ERROR = 'SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_ERROR';
export const CURRENT_ACTIVE_SECTION = 'CURRENT_ACTIVE_SECTION';
export const ACTIVATION_CODE = 'ACTIVATION_CODE';
export const ACTIVATION_CODE_CURRENCY = 'ACTIVATION_CODE_CURRENCY';

// ------------------------------------
// Actions
// ------------------------------------

export function checkoutSubscriptionActivateAccountDetailsStart(social=false) {
  return { type: CHECKOUT_SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_START, payload: { social: social } };
}

export function checkoutSubscriptionActivateAccountDetailsEnd(payload = {}) {
  return { type: CHECKOUT_SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_END, payload };
}

export function raiseErrorSubscriptionActivateAccountDetails() {
  return { type: SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_ERROR };
}

export function checkoutSubscriptionActivatePaymentDetailsStart() {
  return { type: CHECKOUT_SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_START };
}

export function checkoutSubscriptionActivatePaymentDetailsEnd(payload) {
  return { type: CHECKOUT_SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_END, payload };
}

export function checkoutSubscriptionActivateAddressDetailsStart() {
  return { type: CHECKOUT_SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_START };
}

export function checkoutSubscriptionActivateAddressDetailsEnd(payload) {
  return { type: CHECKOUT_SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_END, payload };
}

export function raiseErrorSubscriptionActivatePaymentDetails(payload) {
  return { type: SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_ERROR, payload };
}

export function raiseErrorSubscriptionActivateAddressDetails(payload) {
  return { type: SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_ERROR, payload };
}

export function setCurrentActiveSection(payload) {
  return { type: CURRENT_ACTIVE_SECTION, payload };
}

export function setActivationCode(payload) {
  return { type: ACTIVATION_CODE, payload };
}

export function setActivationCodeCurrency(payload) {
  return { type: ACTIVATION_CODE_CURRENCY, payload };
}

export function saveAddtionalInfoAccountDetails(
  userInfo,
  restrictRedirect,
  cb = () => {}
) {
  return (dispatch) => {
    dispatch(checkoutSubscriptionActivateAccountDetailsStart());
    const { accessToken, ...rest } = userInfo;
    updateAdditionalInfoApi(rest, accessToken)
      .then(() => {
        authCallback({ accessToken }, { restrictRedirect });
        cb({ additionalInfo: { accessToken } });
        dispatch(checkoutSubscriptionActivateAccountDetailsEnd(userInfo));
      })
      .catch((error) => {
        const formattedError = formatErrorMessage(error);
        cb({ message: formattedError });
        dispatch(raiseErrorSubscriptionActivateAccountDetails(error));
      });
  };
}

export function loginAccountDetails(userInfo = {}, cb = () => {}) {
  return (dispatch) => {
    dispatch(checkoutSubscriptionActivateAccountDetailsStart());
    // api call
    signinWebAuth(userInfo)
      .then((res = {}) => {
        const additionalInfo = processAuthInfoForAdditionalInfo(res);
        dispatch(checkoutSubscriptionActivateAccountDetailsEnd(userInfo));
        cb({ additionalInfo });
      })
      .catch((error = {}) => {
        const errorDescription = error.description || '';
        if (
          errorDescription.indexOf(
            'A verification email has been sent to your inbox.'
          ) !== -1
        ) {
          dispatch(checkoutSubscriptionActivateAccountDetailsEnd(userInfo));
          cb({ recurringLogin: true });
        } else {
          cb({ message: error.description });
          dispatch(raiseErrorSubscriptionActivateAccountDetails(error));
        }
      });
  };
}

export function loginAccountDetailsRecurring(userInfo, cb = () => {}) {
  return (dispatch) => {
    // api call
    signinWebAuth(userInfo)
      .then((res) => {
        const additionalInfo = processAuthInfoForAdditionalInfo(res);
        dispatch(checkoutSubscriptionActivateAccountDetailsEnd(userInfo));
        cb({ additionalInfo, closeEmailVerifyModal: true });
      })
      .catch(() => {
        cb({ errorRecurring: true });
      });
  };
}

export function signupAccountDetails(userInfo = {}, cb = () => {}) {
  return (dispatch) => {
    dispatch(checkoutSubscriptionActivateAccountDetailsStart());
    // api call
    signupWebAuth(userInfo)
      .then(() => {
        dispatch(checkoutSubscriptionActivateAccountDetailsEnd(userInfo));
        cb({ recurringLogin: true });
      })
      .catch((error = {}) => {
        cb({ message: error.description });
        dispatch(raiseErrorSubscriptionActivateAccountDetails(error));
      });
  };
}

export function continueWithSocialAccountDetails(connection, userInfo = {}) {
  return (dispatch) => {
    dispatch(checkoutSubscriptionActivateAccountDetailsStart(true));
    // api call
    socialAuthorizationWebAuth(connection, userInfo).then(() => {
      dispatch(checkoutSubscriptionActivateAccountDetailsEnd());
    });
  };
}

export function resetEmailAccountDetails(userInfo = {}, cb = () => {}) {
  return (dispatch) => {
    dispatch(checkoutSubscriptionActivateAccountDetailsStart());
    // api call
    resetPasswordWebAuth(userInfo)
      .then((res) => {
        cb({ message: res, closeResetModal: true });
        dispatch(checkoutSubscriptionActivateAccountDetailsEnd(userInfo));
      })
      .catch((error) => {
        cb({ message: error.description });
        dispatch(raiseErrorSubscriptionActivateAccountDetails(error));
      });
  };
}

export function checkoutAddressSubscriptionActivate(
  addressInfo = {},
  cb = () => {}
) {
  return (dispatch) => {
    dispatch(checkoutSubscriptionActivateAddressDetailsStart());
    checkoutAddressSubscriptionActivateApi(addressInfo)
      .then((res) => {
        dispatch(checkoutSubscriptionActivateAddressDetailsEnd(res));
        cb({ isSuccess: true });
      })
      .catch((error) => {
        const formattedError = formatErrorMessage(error);
        cb({ message: formattedError });
        dispatch(checkoutSubscriptionActivateAddressDetailsEnd());
      });
  };
}

export function checkoutPaymentSubscriptionActivate(
  details = {},
  cb = () => {}
) {
  return (dispatch, getState) => {
    const { subscriptionActivate: { payment: { isFetching } } } = getState();
    dispatch(checkoutSubscriptionActivatePaymentDetailsStart());
    if (!isFetching) {
      checkoutPaymentSubscriptionActivateApi(details)
        .then((res) => {
          if (res.statusCode === 200) {
            dispatch(checkoutSubscriptionActivatePaymentDetailsEnd());
            cb({ isSuccess: true });
          }
        })
        .catch((error) => {
          const formattedError = formatErrorMessage(error);
          cb({ message: formattedError });
          dispatch(checkoutSubscriptionActivatePaymentDetailsEnd());
        });
    }
  };
}

export function getActivationCodeCurrency(args, cb = () => {}) {
  return (dispatch) => {
    fetchPlanCurrencyApi(args)
      .then((res) => {
        if (res.statusCode === 200) {
          dispatch(setActivationCodeCurrency(res.body));
          cb({ isSuccess: true });
        }
      })
      .catch((error) => {
        const formattedError = formatErrorMessage(error);
        cb({ message: formattedError });
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/subscriptionActivate.js